export default __webpack_public_path__ + "static/topNavItems-dont-2-light-85fbdbd403216716d89ab4e13d135b48.png";